import { API } from "../lib/doeApi";

/**
 * Run the DOE calculation via Server-Sent Events.
 * @param {object} params - { network_id, n_steps, v_min, v_max, use_synthetic_profile }
 * @param {object} handlers - { onOpen, onProgress, onResult, onError }
 * @returns {object} { close } - call .close() to abort the stream
 */
export function streamDOE(params, handlers = {}) {
  const qs = new URLSearchParams({
    network_id: params.network_id,
    n_steps: String(params.n_steps),
    v_min: String(params.v_min),
    v_max: String(params.v_max),
    use_synthetic_profile: String(params.use_synthetic_profile ?? true),
    method: params.method || "iterative",
  });
  const url = `${API}/doe/calculate/stream?${qs.toString()}`;
  const es = new EventSource(url);

  es.addEventListener("open", (e) => {
    try {
      handlers.onOpen?.(JSON.parse(e.data));
    } catch {
      handlers.onOpen?.({});
    }
  });

  es.addEventListener("progress", (e) => {
    try {
      handlers.onProgress?.(JSON.parse(e.data));
    } catch {
      /* ignore */
    }
  });

  es.addEventListener("result", (e) => {
    try {
      const result = JSON.parse(e.data);
      handlers.onResult?.(result);
    } catch (err) {
      handlers.onError?.({ message: "Failed to parse result", err });
    }
    es.close();
  });

  es.addEventListener("error", (e) => {
    let payload = null;
    try {
      payload = e?.data ? JSON.parse(e.data) : null;
    } catch {
      /* ignore */
    }
    // Native EventSource onerror fires when connection drops AFTER the
    // result event has closed the stream — only surface real errors.
    if (es.readyState !== EventSource.CLOSED || payload) {
      handlers.onError?.(payload || { message: "Stream connection error" });
    }
    es.close();
  });

  return { close: () => es.close() };
}
